import { CiapCidSelectModel, isCiap } from 'components/form/field/select/CiapCidSelectField/CiapCidSelectField'
import {
  AcompanhamentoCondicaoSaudeQueryInput,
  FaixaEtariaEnum,
  FaixaEtariaInput,
  TipoFiltroLpcEnum,
} from 'graphql/types.generated'
import { isNumber, partition } from 'lodash'
import { idGrupoCondicao } from 'types/enums'
import { isUndefinedOrNull } from 'util/checks'
import { isEmpty } from 'util/validation/Util'

import { convertFaixaEtariaAcompanhamentoInput } from '../converter/converter-faixaEtariaAcompanhamento'
import {
  AcompanhamentoCondicaoSaudeFormModel,
  faixaEtariaRecord,
  ResultadosTriaEnum,
} from './model/model-acompanhamentoCondicaoSaude'

export default (model: AcompanhamentoCondicaoSaudeFormModel): AcompanhamentoCondicaoSaudeQueryInput => {
  const [ciaps, cids] = partition(model?.problemasCondicoes, (item) => isCiap(item))

  return {
    ciaps: ciaps.map((item: CiapCidSelectModel) => item.codigo),
    cid10: cids.map((item: CiapCidSelectModel) => item.codigo),
    grupoCondicao: model?.grupoCondicao?.map((item) => idGrupoCondicao[item.grupo]),
    tipoFiltroLPC: tipoFiltroLPCConverter(model),
    unidadeResponsavelId: model?.unidadeResponsavelId,
    equipeResponsavelId: model.isCoordenador ? model?.equipeResponsavel?.id : model?.equipeResponsavelId,
    sexo: model?.sexo,
    identidadeGenero: model?.identidadeGenero,
    faixaEtaria: convertFaixaEtariaAcompanhamentoInput(model?.tipoFaixaEtaria, mountFaixaEtaria(model)),
    periodoUltimoAtendimento: model?.periodoUltimoAtendimento,
    microareas: model?.microareas,
    periodoCadastroIndividual: model?.tria?.periodoRegistro,
    riscoInsegurancaAlimentar: !isEmpty(model.tria)
      ? model.tria.resultadosTria === ResultadosTriaEnum.RISCO_DE_INSEGURANCA_ALIMENTAR
      : undefined,
    semRegistroTriaNoPeriodo: !isEmpty(model.tria)
      ? model.tria.resultadosTria === ResultadosTriaEnum.SEM_REGISTRO_TRIA_NO_PERIODO
      : undefined,
    // TODO (Royal Flush): Remover isIvcfListing quando listas temáticas forem desflagueadas
    isIvcfListing: model?.isIvcfListing,
    ivcf: !isUndefinedOrNull(model?.ivcf)
      ? {
          exibirApenasCidadaosIdososSemIvcf: model?.ivcf?.exibirApenasCidadaosIdososSemIvcf,
          pontuacaoMin: model?.ivcf?.pontuacao?.firstValue,
          pontuacaoMax: model?.ivcf?.pontuacao?.secondValue,
          riscoVulnerabilidade: !isEmpty(model?.ivcf?.riscoVulnerabilidade)
            ? model?.ivcf?.riscoVulnerabilidade
            : undefined,
          subgrupo: model?.ivcf?.subgrupo,
        }
      : null,
    tematica: model?.listaTematica,
    pageParams: {
      ...model.pageParams,
      sort: model.pageParams?.sort ?? ['microarea', 'cidadao', 'endereco'],
    },
    racaCor: model.racaCor?.value,
  }
}

function mountFaixaEtaria(model: AcompanhamentoCondicaoSaudeFormModel): FaixaEtariaInput {
  const { tipoFaixaEtaria, faixaEtariaRange } = model

  return tipoFaixaEtaria !== FaixaEtariaEnum.OUTRA
    ? faixaEtariaRecord[tipoFaixaEtaria]
    : {
        idadeMinima: faixaEtariaRange?.firstValue,
        idadeMaxima: faixaEtariaRange?.secondValue,
        tipoFaixaEtaria:
          isNumber(faixaEtariaRange?.firstValue) || isNumber(faixaEtariaRange?.secondValue)
            ? faixaEtariaRange?.tipoFaixaEtaria
            : null,
      }
}

function tipoFiltroLPCConverter(model: AcompanhamentoCondicaoSaudeFormModel): TipoFiltroLpcEnum {
  return model?.ativoListaProblema && !model?.naoIncluidoListaProblema
    ? TipoFiltroLpcEnum.SOMENTE_ATIVOS_LPC
    : !model?.ativoListaProblema && model?.naoIncluidoListaProblema
    ? TipoFiltroLpcEnum.SOMENTE_NAO_INCLUIDOS_LPC
    : TipoFiltroLpcEnum.TODOS
}
